import { filter } from 'lodash'

export const getLossReasons = ({ all }) => all

export const getActiveLossReasons = (state) => {
    return filter(state.all, { active: true })
}

export const getInactiveLossReasons = (state) => {
    return filter(state.all, { active: false })
}



// WEBPACK FOOTER //
// ./src/modules/parameters/loss_reasons/store/getters.js